"use client";

import { Box, CardMedia, Container, Link, Stack, Typography } from "@mui/material";
import color from "@/style/theme/Color";
import RightSideBarTentangKami from "@/app/(user)/(tentang-kami)/RightSideBarTentangKami";
import { useContext } from "react";
import MenuContext from "@/context/MenuProvider";

const FasilitasLainnya = () => {
  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          paddingY: 4,
          display: "grid",
          gridTemplateColumns: { md: "auto", xl: "auto 373px" },
          gap: 4
        }}
      >
        <Box>
          <Box>
            {/* Bagian ini buat tester dialog <Button onClick={handleClick}>
                  Click Me
              </Button> */}
          </Box>
          <Box sx={{ marginBottom: "25px" }}>
            <Typography component="h2" sx={{ fontSize: 24, marginBottom: 1, color: color.primary, fontWeight: "bold" }}>
              Loker Penyimpanan
            </Typography>
            <CardMedia
              image={"/image/tentang_kami/loker.webp"}
              sx={{ height: "300px", marginY: "15px" }}
              title={"Meja"}
            />
            <Typography align="justify" >
              Pengunjung perpustakaan tidak diperkenankan membawa tas, jaket, dan topi,
              serta berbagai makanan dan minuman. Jika membawa barang tersebut, pengguna
              perlu menggunakan loker untuk menyimpannya. Peraturan selengkapnya
              ada <Link href="/tata-tertib">di sini</Link>
            </Typography>
          </Box>
          <Box sx={{ marginBottom: "25px" }}>
            <Typography component="h2" sx={{ fontSize: 24, marginBottom: 1, color: color.primary, fontWeight: "bold" }}>
              BI Corner
            </Typography>
            <CardMedia
              image={"/image/tentang_kami/bi.webp"}
              sx={{ height: "300px", marginY: "15px" }}
              title={"Meja"}
            />
            <Typography align="justify" >
              BI Corner merupakan pojok baca sebagai sarana edukasi sekaligus sebagai upaya
              untuk mengenalkan kebijakan BI kepada publik. BI Corner menyediakan berbagai buku
              dalam Bahasa Indonesia dan Bahasa Inggris terkait keuangan dan ekonomi yang dapat
              diakses oleh pengunjung. Jenis bacaan terdiri dari berbagai jenis, mulai dari
              perbankan, ekonomi, keuangan, sampai perpajakan.
            </Typography>
          </Box>
          <Box sx={{ marginBottom: "25px" }}>
            <Typography component="h2" sx={{ fontSize: 24, marginBottom: 1, color: color.primary, fontWeight: "bold" }}>
              Headphone
            </Typography>
            <CardMedia
              image={"/image/tentang_kami/headphone.webp"}
              sx={{ height: "300px", marginY: "15px" }}
              title={"Meja"}
            />
            <Typography align="justify" >
              Penyediaan headphone berguna untuk menciptakan suasana
              yang nyaman, karena dapat mengurangi gangguan dari luar
              dan dapat mendengarkan suara, lagu, video pembelajaran
              maupun audiolib tanpa mengganggu orang lain.
            </Typography>
          </Box>
        </Box>
        <RightSideBarTentangKami
          menu-is-active={"Fasilitas"}
          submenu-is-active={"Fasilitas Lainnya"}
        />
      </Container>
    </>
  );

};

export default FasilitasLainnya;
